/**
 * Nombre de marca por defecto cuando el super-admin no ha configurado uno
 * propio desde "Marca de la aplicación" (`/marca-app`). Único punto de
 * verdad: evita que el literal "DeKA" se repita, y se desincronice, en
 * varios componentes (`AppLayout.tsx`, `LoginPage.tsx`, `PlatformBrandingPage.tsx`).
 */
export const DEFAULT_APP_NAME = "DeKA";

/** `appName` viene de `GET /api/v1/branding`; `null`/`undefined` cae al valor por defecto. */
export function resolveAppName(appName: string | null | undefined): string {
  return appName && appName.trim().length > 0 ? appName : DEFAULT_APP_NAME;
}
